export default "__VITE_ASSET__Ba3zA30J__"